import { render, staticRenderFns } from "./DocNode.vue?vue&type=template&id=37420246&scoped=true"
import script from "./DocNode.vue?vue&type=script&lang=js"
export * from "./DocNode.vue?vue&type=script&lang=js"
import style0 from "./DocNode.vue?vue&type=style&index=0&id=37420246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37420246",
  null
  
)

export default component.exports